export default "__VITE_ASSET__7034756b__"